/*
 * Pure helpers for 1:1 reply/quote in the inbox. No Preact / store deps.
 */

// Find the message a reply points at, within the currently-loaded messages.
export function findQuotedMessage(messages, replyToUuidv4) {
    if (!Array.isArray(messages) || !replyToUuidv4) {
        return null;
    }
    return messages.find(m => m.uuidv4 === replyToUuidv4) || null;
}

// A short single-line snippet of a quoted message body.
export function quoteSnippet(body, max = 80) {
    const text = (body || '').replace(/\s+/g, ' ').trim();
    if (text.length <= max) {
        return text;
    }
    return `${text.slice(0, max)}…`;
}
